import React from "react";
import { Navigate } from "react-router-dom";
import MyProperties from "../pages/MyProperties/MyProperties";
import Profilecard from "../pages/ProfileCard/Profilecard";
import Tempaltes from "../pages/Templates";
import Docs from "../pages/UserDocs";
import CG_WelcomScreen from "../pages/contractgeneration/CG_WelcomScreen";
import QuestionAireScreen from "../pages/contractgeneration/QuestionAireScreen";
import CG_PreviewContract from "../pages/contractgeneration/CG_PreviewContract";
import CG_FinalReview from "../pages/contractgeneration/CG_FinalReview";
import CG_ESignContract from "../pages/contractgeneration/CG_ESignContract";
import CG_SuccessPage from "../pages/contractgeneration/CG_SuccessPage";
import CG_Questions from "../pages/contractgeneration/CG_Questions";
import Getqualified from "../pages/GetQualified/FinancialPreQualification/FinancialPreQualification";
import GeneralInformationForm from "../pages/GetQualified/GeneralInformationForm/GeneralInformationForm";
import FormQuestion from "../pages/GetQualified/PreQualification/PreQualification";
import StepFour from "../pages/GetQualified/StepFour/StepFour";
import StepFive from "../pages/GetQualified/StepFive/StepFive";
import StepSix from "../pages/GetQualified/StepSix/StepSix";
import Success from "../pages/GetQualified/Success/Success";
import AccountSettings from "../pages/AccountSettings/AccountSettings";
import ProfileSettings from "../pages/AccountSettings/ProfileSettings/ProfileSettings";
import SecuritySettings from "../pages/AccountSettings/SecuritySettings/SecuritySettings";
import LocationSelector from "../pages/AccountSettings/LocationSelector/LocationSelector";
import NotificationSettings from "../pages/AccountSettings/NotificationSettings/NotificationSettings";
import ProfilePage from "../pages/AccountSettings/ProfilePage/ProfilePage";
import ShareComponent from "../components/ShareComponent/ShareComponent";
import HomeInspectionScheduler from "../pages/Inspector/HomeInspectionScheduler/HomeInspectionScheduler";
import ConfirmationPreparation from "../pages/Inspector/ConfirmationPreparation/ConfirmationPreparation";
import PublicPages from "../pages/PublicPages/PublicPages";
import HomeInsurance from "../pages/HomeInsurance/HomeInsurance";
import ChangePassword from "../pages/AccountSettings/SecuritySettings/ChangePassword";
import ChangeEmail from "../pages/AccountSettings/SecuritySettings/ChangeEmail";
import PrivacyPolicyScreen from "../pages/PrivacyPolicyScreen";
import TitleService from "../pages/TitleServices/TitleServicePreQualification/TitleServicePreQualification";
import AcquaintedInformationForm from "../pages/TitleServices/GeneralInformationForm/AcquaintedInformationForm";
import TitleStepThree from "../pages/TitleServices/StepThree/StepThree";
import TitleStepFour from "../pages/TitleServices/StepFour/StepFour";
import TitleServiceConfirmation from "../pages/TitleServices/TitleConfirmation/TitleConfirmation";
import StepOneInsurance from "../pages/HomeInsurance/StepOne/StepOne";
import StepTwoInsurance from "../pages/HomeInsurance/StepTwo/StepTwo";
import StepThreeInsurance from "../pages/HomeInsurance/StepThree/StepThree";
import InsuranceServiceConfirmation from "../pages/HomeInsurance/Confirmation/InsuranceConfirmation";
import StartVerification from "../pages/AccountSettings/GetVerification/StartVerification";

import SelectDocumentType from "../pages/AccountSettings/GetVerification/StepOne";
import UploadAndReviewDoc from "../pages/AccountSettings/GetVerification/StepTwo";
import FaceLiveness from "../pages/AccountSettings/GetVerification/StepThree";
import PreviewPage from "../pages/Preview/Preview";
import TitleStepTwo from "../pages/TitleServices/StepTwo/StepTwo";
import StepFourInsurance from "../pages/HomeInsurance/StepFour/StepFour";
import StepFiveInsurance from "../pages/HomeInsurance/StepFive/StepFive";
import Dashboard from "../pages/Chat/ChatList";
import StepTwo from "../pages/GetQualified/StepTwo/StepTwo";
import SellWelcomeScreen from "../pages/Sellform/SellWelcomeScreen";
import InspectorPreQualified from "../pages/Inspector/InspectorList";
import VerifyOTP from "../pages/Auth/OtpVerification";
import ResetPasswordSuccess from "../pages/Auth/ResetPasswordSuccess";
import GeneralInfoHomeInspection from "../pages/Inspector/GeneralInformation/GeneralInformation";
import VerifiedSuccessfully from "../pages/AccountSettings/GetVerification/VerifiedSuccess";
import InspectionPropertyInfo from "../pages/Inspector/PropertyInformation/PropertyInformation";
import DataDeletionInstructions from "../pages/DataDeletionInstructions";
import ManageSubscription from "../pages/MyProperties/ManageSubscription";
import CompanyInformation from "../pages/AccountSettings/GetVerification/CompanyVerifications/CompanyInformation";
import UploadCompanyDocument from "../pages/AccountSettings/GetVerification/CompanyVerifications/UploadCompanyDocument";
import CompanyVerificationSuccess from "../pages/AccountSettings/GetVerification/CompanyVerifications/CompanyVerificationSuccess";
import UploadCompanyOwnerDocuments from "../pages/AccountSettings/GetVerification/CompanyVerifications/UploadCompanyOwnerDocuments";
import DeleteAccountPage from "../pages/DeleteAccountPage";
import PasswordFromToken from "../pages/Auth/PasswordFromToken";
import Sell from "../pages/Sellform/Sell";
// normal imports

// auth
import Login from "../pages/Auth/Login";
import Logout from "../pages/Auth/Logout";
import ForgetPassword from "../pages/Auth/ForgetPassword";
import Register from "../pages/Auth/Register";

import VerificationPage from "../pages/Auth/VerificationPage";
import ResetPassword from "../pages/Auth/ResetPassword";

import Properties from "../pages/Properties/properties";

// Add Favorites component
import Favorites from "../pages/FavoriteProperties";

// declare all routes
const authProtectedRoutes = [
    { path: "/chat", component: <Dashboard /> },
    { path: "/properties", component: <Properties /> },
    { path: "/favorites", component: <Favorites /> },
    { path: "/services/financing", component: <Getqualified /> },
    { path: "/get-qualified/Step-1", component: <GeneralInformationForm /> },
    { path: "/get-qualified/Step-2", component: <StepTwo /> },
    { path: "/get-qualified/Step-3", component: <FormQuestion /> },
    { path: "/get-qualified/Step-4", component: <StepFour /> },
    { path: "/get-qualified/Step-5", component: <StepFive /> },
    { path: "/get-qualified/Step-6", component: <StepSix /> },
    { path: "/get-qualified/success", component: <Success /> },

    { path: "/services/title-services", component: <TitleService /> },
    { path: "/get-title/Step-1", component: <AcquaintedInformationForm /> },
    { path: "/get-title/Step-2", component: <TitleStepTwo /> },
    { path: "/get-title/Step-3", component: <TitleStepThree /> },
    { path: "/get-title/Step-4", component: <TitleStepFour /> },
    { path: "/get-title/title-confirmation", component: <TitleServiceConfirmation /> },
    { path: "/list-property", component: <Sell /> },
    { path: "/MyProperties", component: <MyProperties /> },
    { path: "/MyProperties/:id/manage-plan", component: <ManageSubscription /> },
    { path: "/ProfileDetails", component: <Profilecard /> },
    { path: "/users/docs/", component: <Docs /> },
    { path: "/Settings", component: <AccountSettings /> },
    { path: "/documents/templates/", component: <Tempaltes /> },
    { path: "/contract-generation/welcome/", component: <CG_WelcomScreen /> },
    { path: "/profile-detail", component: <ProfileSettings /> },
    { path: "/sign-in-security", component: <SecuritySettings /> },
    { path: "/change-password", component: <ChangePassword /> },
    { path: "/change-email", component: <ChangeEmail /> },
    { path: "/saved-searches", component: <LocationSelector /> },
    { path: "/Notifications", component: <NotificationSettings /> },
    { path: "/Profile", component: <ProfilePage /> },
    { path: "/share", component: <ShareComponent /> },
    { path: "/services/home-Inspection", component: <InspectorPreQualified /> },
    { path: "/services/general-info-home-inspection", component: <GeneralInfoHomeInspection /> },
    { path: "/services/inspection-property-info", component: <InspectionPropertyInfo /> },
    { path: "/services/home-inspection-Schedule", component: <HomeInspectionScheduler /> },
    { path: "/services/home-inspection-confirmation", component: <ConfirmationPreparation /> },
    { path: "/services/insurance-quote", component: <HomeInsurance /> },
    { path: "/services/insurance-quote/step-1", component: <StepOneInsurance /> },
    { path: "/services/insurance-quote/step-2", component: <StepTwoInsurance /> },
    { path: "/services/insurance-quote/step-3", component: <StepThreeInsurance /> },
    { path: "/services/insurance-quote/step-4", component: <StepFourInsurance /> },
    { path: "/services/insurance-quote/step-5", component: <StepFiveInsurance /> },
    { path: "/services/insurance-quote/confirmation", component: <InsuranceServiceConfirmation /> },
    { path: "/privacy-policy", component: <PrivacyPolicyScreen /> },
    { path: "/start-verification", component: <StartVerification /> },
    { path: "/verify/step-1", component: <SelectDocumentType /> },
    { path: "/verify/step-2", component: <UploadAndReviewDoc /> },
    { path: "/verify/step-3", component: <FaceLiveness /> },
    { path: "/verify/success", component: <VerifiedSuccessfully /> },
    { path: "/company-verification/information", component: <CompanyInformation /> },
    { path: "/company-verification/upload-documents", component: <UploadCompanyDocument /> },
    { path: "/company-verification/success", component: <CompanyVerificationSuccess /> },
    { path: "/company-verification/owner-documents", component: <UploadCompanyOwnerDocuments /> },
    {
        path: "/contract-generation/questionaire",
        component: <QuestionAireScreen />,
    },
    {
        path: "/contract-generation/preview-contract",
        component: <CG_PreviewContract />,
    },
    {
        path: "/contract-generation/final-review",
        component: <CG_FinalReview />,
    },
    {
        path: "/delete-account",
        component: <DeleteAccountPage />,
    },
    {
        path: "/contract-generation/esign-contract",
        component: <CG_ESignContract />,
    },
    {
        path: "/contract-generation/contract-submitted",
        component: <CG_SuccessPage />,
    },
    { path: "/preview/:id", component: <PreviewPage /> },

    {
        path: "/contract-generation/questions",
        component: <CG_Questions />,
    },
    {
        path: "/list-property/welcome",
        component: <SellWelcomeScreen />,
    },
    // this route should be at the end of all other routes
    // eslint-disable-next-line react/display-name
    {
        path: "/",
        exact: true,
        component: <Navigate to="/properties" />,
    },
    { path: "*", component: <Navigate to="/properties" /> },
];

const publicRoutes = [
    { path: "/logout", component: <Logout /> },
    { path: "/login", component: <Login /> },
    { path: "/preview/:id", component: <PreviewPage /> },
    { path: "/project-api/public", component: <PreviewPage /> },
    { path: "/forget-password", component: <ForgetPassword /> },
    { path: "/verify-otp", component: <VerifyOTP /> },
    { path: "/reset-password", component: <ResetPassword /> },
    { path: "/new-password", component: <PasswordFromToken /> },
    { path: "/reset-password/success", component: <ResetPasswordSuccess /> },
    { path: "/register", component: <Register /> },
    { path: "/verify-email", component: <VerificationPage /> },
    { path: "/public", component: <PublicPages /> },
    { path: "/privacy-policy", component: <PrivacyPolicyScreen /> },
    { path: "/data-deletion-instructions", component: <DataDeletionInstructions /> },
    { path: "*", component: <Navigate to="/login" /> },
];

export { authProtectedRoutes, publicRoutes };
